import { AdminUser } from "@medusajs/types"
import { UserInfo } from "types"

export interface VendorUser extends AdminUser {
  vendor_id: string
  full_name: string
}

export interface VendorUserResponse {
  user: VendorUser
}

export class User {
  private client: unknown

  /**
   * @ignore
   */
  constructor(client: unknown) {
    this.client = client
  }

  // async create(body: any, query?: any, headers?: any): Promise<any> {
  //   return this.client.fetch(`/admin/users`, {
  //     method: "POST",
  //     headers,
  //     body,
  //     query,
  //   });
  // }

  // async update(id: string, body: any, query?: any, headers?: any): Promise<any> {
  //   return this.client.fetch(`/admin/users/${id}`, {
  //     method: "POST",
  //     headers,
  //     body,
  //     query,
  //   });
  // }

  // async list(queryParams?: any, headers?: any): Promise<any> {
  //   return this.client.fetch(`/admin/users`, {
  //     headers,
  //     query: queryParams,
  //   });
  // }

  // async retrieve(id: string, query?: any, headers?: any): Promise<any> {
  //   return this.client.fetch(`/admin/users/${id}`, {
  //     query,
  //     headers,
  //   });
  // }

  // async delete(id: string, headers?: any): Promise<any> {
  //   return this.client.fetch(`/admin/users/${id}`, {
  //     method: "DELETE",
  //     headers,
  //   });
  // }

  async me(query?: unknown, headers?: unknown): Promise<UserInfo> {
    return (this.client as any).fetch(`/authen/me`, {
      query,
      headers,
    })
  }
}
